let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aOvi5")).then(() => parcelRequire('hA9wZ'));